/** @jsx jsx */
import {jsx} from 'theme-ui'
import BackArrow from 'images/components/BackArrow.svg'
import {useTranslation, Trans} from 'react-i18next'

type Props = {
  handleBackClick: () => void
}

const ThankYouBox: React.FC<Props> = ({handleBackClick}) => {
  const {t} = useTranslation()
  return (
    <div sx={{p: 20}}>
      <button
        onClick={handleBackClick}
        type="button"
        sx={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'transparent',
          border: 'none',
          color: '#A7A7A7',
          fontSize: 16,
          cursor: 'pointer',
        }}
      >
        <BackArrow sx={{mr: 12}} />
        {t('Back')}
      </button>
      <h3
        sx={{
          textAlign: 'center',
        }}
      >
        {t('thankYouBoxTitle')}
      </h3>
      <p
        sx={{
          fontSize: 14,
          lineHeight: '18px',
          color: 'soft',
        }}
      >
        {t('thankYouBoxText')}
      </p>

      <p
        sx={{
          lineHeight: '24px',
          textAlign: 'center',
        }}
      >
        <Trans i18nKey="thankYouBoxOutro">
          Through your donation, you are also:
          <br />
          <b>With Humanity. Everywhere.</b>
        </Trans>
      </p>
    </div>
  )
}

export default ThankYouBox
